import { render } from "./YqTable.vue?vue&type=template&id=dafe00ce"
import script from "./YqTable.vue?vue&type=script&lang=js"
export * from "./YqTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__